import Router from 'vue-router'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/home/index'),
    meta: { title: '首页' }
  },
  {
    path: '/agent',
    name: 'AgentHome',
    component: () => import('@/pages/agent/index'),
    redirect: '/agent/index',
    children: [
      {
        path: 'index',
        name: 'AgentIndex',
        component: () => import('@/pages/agent/index/index'),
        meta: { title: '代理首页' }
      },
      {
        path: 'downline',
        name: 'AgentDownline',
        component: () => import('@/pages/agent/downline/index'),
        meta: { title: '我的代理' }
      },
      {
        path: 'bill',
        name: 'AgentBill',
        component: () => import('@/pages/agent/bill/index'),
        meta: { title: '代理账单核对' }
      },
      {
        path: 'bill-detail',
        name: 'AgentBillDetail',
        component: () => import('@/pages/agent/bill/bill-list'),
        meta: { title: '代理账单音乐人明细' }
      },
      {
        path: 'withdraw',
        name: 'AgentWithdraw',
        component: () => import('@/pages/agent/withdraw/index'),
        meta: { title: '提现功能' }
      },
      {
        path: '/agent/withdraw/to-card',
        name: 'AgentWithdrawCard',
        component: () => import('@/pages/agent/withdraw/withdraw-card'),
        meta: { title: '提现' }
      },
      {
        path: '/agent/withdraw/bind-card',
        name: 'AgentBindCard',
        component: () => import('@/pages/agent/withdraw/bind-card'),
        meta: { title: '绑卡' }
      },
      {
        path: '/agent/withdraw/withdraw-record',
        name: 'AgentWithdrawRecord',
        component: () => import('@/pages/agent/withdraw/withdraw-record'),
        meta: { title: '提现记录' }
      },
      {
        path: 'generate-agent',
        name: 'GenerateAgent',
        component: () => import('@/pages/agent/generate/index'),
        meta: { title: '生成代理' }
      },
      {
        path: 'check-success',
        name: 'CheckSuccess',
        component: () => import('@/pages/agent/generate/check-success'),
        meta: { title: '校验结果' }
      },
      {
        path: 'generate-res',
        name: 'GenerateResult',
        component: () => import('@/pages/agent/generate/result'),
        meta: { title: '创建成功' }
      },
      {
        path: 'generate-list',
        name: 'GenerateAgentList',
        component: () => import('@/pages/agent/generate/list'),
        meta: { title: '邀请列表' }
      }
    ]
  },
  {
    path: '/music',
    name: 'Music',
    component: () => import('@/pages/music/index'),
    meta: { title: '我的作品' },
    redirect: '/music/list',
    children: [
      {
        path: 'list',
        name: 'MusicList',
        component: () => import('@/pages/music/list/index'),
        meta: { title: '作品列表' }
      },
      {
        path: 'single',
        name: 'SingleMusic',
        component: () => import('@/pages/music/detail/single'),
        meta: { title: '单曲详情' }
      },
      {
        path: 'album',
        name: 'AlbumMusic',
        component: () => import('@/pages/music/detail/album'),
        meta: { title: '专辑详情' }
      }
    ]
  },
  {
    path: '/guide',
    name: 'Guide',
    component: () => import('@/pages/guide/index'),
    meta: { title: '作品上传' }
  },
  {
    path: '/advisory',
    name: 'Advisory',
    component: () => import('@/pages/advisory/index'),
    meta: { title: '服务咨询' },
  },
  {
    path: '/advisory/detail',
    name: 'AdvisoryDetail',
    component: () => import('@/pages/advisory/detail'),
    meta: { title: '正文', keepAlive: true }
  },
  {
    path: '/me',
    name: 'Me',
    component: () => import('@/pages/me/index'),
    meta: { title: '个人中心' }
  },
  {
    path: '/me/update-info',
    name: 'UpdateInfo',
    component: () => import('@/pages/me/update-info/index'),
    meta: { title: '修改信息' }
  },
  {
    path: '/me/reset-pwd',
    name: 'ResetPwd',
    component: () => import('@/pages/me/reset-pwd/index'),
    meta: { title: '修改密码' }
  },
  {
    path: '/bill',
    name: 'Bill',
    component: () => import('@/pages/bill/index'),
    meta: { title: '账单核对' }
  },
  {
    path: '/bill-list',
    name: 'BillList',
    component: () => import('@/pages/bill/bill-list'),
    meta: { title: '账单明细', keepAlive: true }
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/pages/withdraw/index'),
    meta: { title: '提现功能' }
  },
  {
    path: '/withdraw/to-card',
    name: 'WithdrawCard',
    component: () => import('@/pages/withdraw/withdraw-card'),
    meta: { title: '提现' }
  },
  {
    path: '/withdraw/bind-card',
    name: 'BindCard',
    component: () => import('@/pages/withdraw/bind-card'),
    meta: { title: '绑卡' }
  },
  {
    path: '/withdraw/withdraw-record',
    name: 'WithdrawRecord',
    component: () => import('@/pages/withdraw/withdraw-record'),
    meta: { title: '提现记录' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login/index'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/register/index'),
    meta: { title: '注册' }
  },
  {
    path: '/children-reg',
    name: 'ChildrenReg',
    component: () => import('@/pages/register/children-reg'),
    meta: { title: '未成年人注册' }
  },
  {
    path: '/children-reg-h5',
    name: 'ChildrenRegH5',
    component: () => import('@/pages/register/children-reg-h5'),
    meta: { title: '未成年人注册' }
  },
  {
    path: '/realidcation',
    name: 'Realidcation',
    component: () => import('@/pages/register/realidcation'),
    meta: { title: '未成年人信息补充' }
  },
  {
    path: '/find-password',
    name: 'FindPassword',
    component: () => import('@/pages/find-password/index'),
    meta: { title: '忘记密码' }
  },
  {
    path: '/help',
    name: 'HelpCenter',
    component: () => import('@/pages/help/index'),
    redirect: '/help/list',
    meta: { title: '帮助中心' },
    children: [
      {
        path: 'list',
        name: 'HelpList',
        component: () => import('@/pages/help/list/index'),
        meta: { title: '帮助列表' }
      },
      {
        path: 'sub-list',
        name: 'SubList',
        component: () => import('@/pages/help/list/sub-list'),
        meta: { title: '帮助列表' }
      },
      {
        path: 'detail',
        name: 'HelpDetail',
        component: () => import('@/pages/help/detail/index'),
        meta: { title: '问题详情' }
      }
    ]
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/pages/message/index'),
    meta: { title: '消息中心' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/pages/about/index'),
    meta: { title: '关于我们' }
  },
  {
    path: '/feature-list',
    name: 'FeatureList',
    component: () => import('@/pages/about/feature-list'),
    meta: { title: '系统通知' }
  },
  {
    path: '/feature-detail',
    name: 'FeatureDetail',
    component: () => import('@/pages/about/feature-detail'),
    meta: { title: '更新详情' }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/pages/feedback'),
    meta: { title: '意见反馈' }
  }

  // {
  //   path: '/404',
  //   component: () => import('@/views/404'),
  //   hidden: true
  // },
  // { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  routes: constantRoutes
})

const router = createRouter()

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default router
